/**
 * Route-level pending state (§4.4): a skeleton that matches the landing layout, then after ten seconds the
 * kit's DelayNotice with a retry. Used as the Suspense fallback for lazy routes and while a lottery loads.
 */
import { DelayNotice, Skeleton, useIntl } from '@windrop/ui';

export interface RouteLoadingProps {
  label?: string;
  onRetry?: () => void;
  /** 'lottery' = hero + facts + CTA; 'page' = heading + paragraphs. */
  shape?: 'lottery' | 'page';
}

export function RouteLoading({ label, onRetry, shape = 'page' }: RouteLoadingProps) {
  const { t } = useIntl();
  const text = label ?? t('shell.loading', {}, 'Loading');
  return (
    <div className="page" data-testid="route-loading">
      <DelayNotice message={t('shell.delay')} retryLabel={t('shell.retry', {}, 'Retry')} onRetry={onRetry}>
        <div role="status" aria-label={text} className="stack">
          {shape === 'lottery' ? (
            <>
              <Skeleton shape="text" width="40%" height={20} />
              <Skeleton shape="block" height={240} />
              <Skeleton shape="display" width="80%" />
              <Skeleton shape="text" width="60%" />
              <Skeleton shape="block" height={56} />
              <Skeleton shape="text" width="70%" />
            </>
          ) : (
            <>
              <Skeleton shape="display" width="70%" />
              <Skeleton shape="text" />
              <Skeleton shape="text" width="90%" />
              <Skeleton shape="block" height={120} />
            </>
          )}
        </div>
      </DelayNotice>
    </div>
  );
}
